import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import BasePage from '../../baseClasses/BasePage';
import MobileTaskDetails from '../../containers/TasksContainer/MobileTaskDetails';
import MobileHeader from '../../components/MobileHeader';
import MobileSpinner from '../../components/MobileSpinner';
import dataModel from '../../models/DataModel';
import '../MobileWrapper.scss';
import mobileBridge from '../../helpers/MobileBridge';
import DataSource from '../../dao/DataSource/DataSource';

const taskDescriptor = {
  task: {
  },
};

// project is only used by <MobileAssignmentsTab>
const shallowProjectDescriptor = {
  project: {
    users: {
      companies: {},
    },
    unique_documents: {},
  },
};

class TasksDetailWrapper extends BasePage {
  constructor(props) {
    super(props);
    this.state = { 
      isInitialized: false, 
    };
  }

  handleUpdateTask(task, action) {
    this.setState({ task });
    if (action != 'prefetch' && !this.state.project) {
      if (this.projectDataSource) {
        this.projectDataSource.release();
      }
      this.projectDataSource = new DataSource('Project', task.project_id, shallowProjectDescriptor, this.handleUpdateProject);
      this.projectDataSource.get();
    }
  }

  handleUpdateProject(project) {
    this.setState({ project });
  }

  componentDidMount() {
    mobileBridge.initialize(this.props.history);

    this.taskDataSource = new DataSource('Task', this.props.match.params.task_id, taskDescriptor, this.handleUpdateTask);
    this.taskDataSource.get();

    // register for speech detection
    dataModel.mobileBridge.addSpeechDetectedObserver(this.handleSpeechDetected);
  }

  componentWillUnmount() {
    if (this.taskDataSource) {
      this.taskDataSource.release();
      this.taskDataSource = null;
    }
    if (this.projectDataSource) {
      this.projectDataSource.release();
      this.projectDataSource = null;
    }

    //unregister for speech detection
    dataModel.mobileBridge.removeSpeechDetectedObserver(this.handleSpeechDetected);
  }

  componentDidUpdate(prevProps) {
    const prevParams = prevProps.match ? prevProps.match.params : {};
    const nextParams = this.props.match ? this.props.match.params : {};
    if (nextParams.task_id != prevParams.task_id ||
      prevProps.navigateUri != this.props.navigateUri) {
      if (this.taskDataSource) {
        this.taskDataSource.release();
      }
      this.setState({ project: null });
      this.taskDataSource = new DataSource('Task', this.props.match.params.task_id, taskDescriptor, this.handleUpdateTask);
      this.taskDataSource.get();
    }
  }

  handleSpeechDetected(speechText) {
    const { task } = this.state;
    
    const speechDataLowerWithoutSpaces = speechText.replace(/ /g, '').toLowerCase();
    if (speechDataLowerWithoutSpaces == 'startwork') {
      //push to completion step and indicate hands free mode, send ids
      this.props.history.push({
        pathname: `/mobile/projects-tasks/task/${task.id}/completion_step/${task.completion_criteria[0].id}`,
      });
    }
    else {
      setTimeout(() => {
        dataModel.showGlobalModal('HANDSFREE_ERROR_MODAL', {
          message: 'Hint: try saying start work',
        });
      }, 2000);
    }
  }

  handleRefDocOpen() {
    this.setState({ refDocOpen: true });
  }
  handleCloseRefDoc() {
    this.setState({ refDocOpen: false });
  }

  render() {
    if (
      !this.props.currentUser ||
      !this.props.currentCompany ||
      !this.props.permissions ||
      !this.state.task ||
      !this.state.project
    ) {
      return null;
    }

    this.setWhiteLabels(this.props.currentCompany);

    let { refDocOpen } = this.state;

    if (!this.state.task) {
      return (
        <div className="mobile-wrapper">
          <MobileHeader
            headerTitle={this.textMap.task}
            rootPage={this.props.rootPage}
            useDoneButton={this.state.refDocOpen}
            navigateBack={this.handleCloseRefDoc}
            displayHandsFree={true}
          />
          <MobileSpinner/>
        </div>
      );
    }
    return (
      <div className="mobile-wrapper" key={this.props.match.params.task_id}>
        {this.props.systemPopup}
        <MobileHeader
          headerTitle={this.textMap.task}
          rootPage={this.props.rootPage}
          useDoneButton={refDocOpen}
          navigateBack={refDocOpen ? this.handleCloseRefDoc : null}
          displayHandsFree={true}
        />
        <div className="content-wrapper">  
        <MobileTaskDetails
          task={this.state.task}
          project={this.state.project}
          handleRefDocOpen={this.handleRefDocOpen}
          refDocOpen={refDocOpen}
        />
        </div>  
      </div>
    );
  }
}

TasksDetailWrapper.defaultProps = {
  rootPage: false,
};

const mapStateToProps = (state, ownProps) => {
  return {
    navigateUri: state.main.navigateUri,
    permissions: state.new_users.permissions,
    currentUser: state.new_users.currentUser,
    currentCompany: state.new_companies.currentCompany,
    systemPopup: state.main.systemPopup,
  };
};

export default withRouter(connect(mapStateToProps)(TasksDetailWrapper));



// WEBPACK FOOTER //
// ./src/mobileWrappers/TaskDetailWrapper/index.js